import Text from 'components/cms/dataTypes/Text';
import RichText from 'components/cms/dataTypes/RichText';
import Image from 'components/cms/dataTypes/Image';
import Button from 'components/cms/dataTypes/Button';
import ButtonSlim from 'components/cms/dataTypes/ButtonSlim';
import Modal from 'components/cms/dataTypes/Modal';
import Accordion from 'components/cms/dataTypes/Accordion';
import Tabs from 'components/cms/dataTypes/Tabs';
import Slider from 'components/cms/dataTypes/Slider';
import Heading from 'components/cms/dataTypes/Heading';
import Social from 'components/cms/dataTypes/Social';
import ImageTextOverlay from 'components/cms/dataTypes/ImageTextOverlay';
import Video from 'components/cms/dataTypes/Video';
import LookBook from 'components/cms/dataTypes/LookBook';
import Grid from 'components/cms/dataTypes/Grid';
import ConnectionPanel from 'components/cms/dataTypes/ConnectionPanel';
import LoaderTrigger from '../dataTypes/LoaderTrigger';

export default {
  'data-types.heading': Heading,
  'data-types.text': Text,
  'data-types.rich-text': RichText,
  'data-types.image': Image,
  'data-types.button': Button,
  'data-types.button-slim': ButtonSlim,
  'data-types.modal': Modal,
  'data-types.accordion': Accordion,
  'data-types.tabs': Tabs,
  'data-types.slider': Slider,
  'data-types.social': Social,
  'data-types.image-text-overlay': ImageTextOverlay,
  'data-types.video': Video,
  'data-types.grid': Grid,
  'data-types.look-book': LookBook,
  'data-types.connection-panel': ConnectionPanel,
  'data-types.loader-trigger': LoaderTrigger,
};
